import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { MegaMenuItem } from 'primeng/api';
import { GeneralServiceService } from 'src/app/services/general-service.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Constants } from 'src/environments/environment';

@Component({
  selector: 'app-home-test',
  templateUrl: './homeTest.component.html',
  styleUrls: ['./homeTest.component.scss']
})
export class HomeTestComponent implements OnInit {
  listaProdotti: any[] = [];
  listaProdottiPromo: any[] = [];
  listaProdottiVenduti: any[] = [];
  listaProdottiEvidenza: any[] = [];
  listaSlide: any[] = [];
  titoloProd: any = "Novità";
  page: string = "home";
  nomeAzienda: string;
  loggato: boolean = false;
  isMobile: boolean = false;
  listLinee: any[] = [];
  gfg: MegaMenuItem[];
    constructor(config: NgbCarouselConfig, public genericFunc: GeneralServiceService, 
      private local: LocalStorageService, private router: Router) { 
      config.interval = 2000;  
      config.wrap = true;  
      config.keyboard = false;  
      config.pauseOnHover = false; 
    }

  ngOnInit(): void {
    this.genericFunc.lineaSelezionata = [];
    this.nomeAzienda = Constants.nomeBreve;
    if (window.screen.width < 500) { // 768px portrait
      this.isMobile = true;
    }
    this.getCategorie();
    this.getLinee();
     
  }

  getLinee() {
    let dataCategorie = {func:"CatHomeImg", tipo: "L"};
    this.genericFunc.genericFunction(dataCategorie).subscribe( response => {
      console.log(response);
      if (response) {
        this.listLinee = response.Cat;
      }

    });
  }

  getCategorie() {
    let dataCategorie = {func:"CatSideBar"};
    this.genericFunc.genericFunction(dataCategorie).subscribe( response => {
      console.log(response);
      let cat = response['Categorie'];
      let catTemp: any[] = [];
      

      for (let i= 0; i<cat.length;i++) {
        console.log(cat[i]);
        let arrChild: any[] = [];
        let length;
        if (cat[i]['children'].length <= 6) {
          length = Math.round(cat[i]['children'].length/2);
        } else {
          length = Math.round(cat[i]['children'].length/3);
        }
         
        let child: any[] = new Array();
        for (let x=0;x<length;x++) {
          child[x] = new Array();
          let start;
          let end;
           if (cat[i]['children'].length <= 6) {
            
             start = x*2;
             end = start+2;
          } else { 
            start = x*3;
            end = start+3;
          }
          
          for (let y=start;y<end; y++) {
            let child1 = cat[i]['children'];
            
            if (child1[y]) {
              if (child1[y]['children']) {
                
                let arrChild3: any[] = [];
                for (let j =0;j<child1[y]['children'].length;j++) {
                  let child3=child1[y]['children'];
                 
                  arrChild3.push({ id: child3[j]['idcat'], label: child3[j]['titolo'], routerLink: "/elencoProdottiCat/"+child3[j]['idcat']+"/2", routerLinkActiveOptions: { exact: true }  });
                }
                child[x].push({id: child1[y]['idcat'], label: child1[y]['titolo'], items: arrChild3});
              } else {
                child[x].push({id: child1[y]['idcat'], label: child1[y]['titolo'], items:[{id: child1[y]['idcat'], label: child1[y]['titolo'],   routerLink:["/elencoProdottiCat/"+child1[y]['idcat']+"/1"], routerLinkActiveOptions: { exact: true } }],  routerLink:["/elencoProdottiCat/"+child1[y]['idcat']], routerLinkActiveOptions: { exact: true } });
              }
              
            }
           
          }
         // child[x].push(arrChild);
        }
       
        
        console.log(length + " - " + Math.round(length/3));
        
       
        let temp = {id: cat[i]['idcat'], label: cat[i]['titolo'], items: child};
        catTemp.push(temp);
      
      }

      this.gfg = catTemp;
      console.log(this.gfg);
      
      
    });
  }

  openGruppo(linea) {
   
    this.genericFunc.lineaSelezionata = linea;
    this.router.navigate(['home-gruppi']);
  }

  ngAfterViewInit() {
    if (this.local.getLocal('username') != "" && this.local.getLocal('username') != null && this.local.getLocal('username') != 'null') {
      let datiLogin = {func: 'checkToken', token: this.local.getLocal('token'), idut: this.local.getLocal('idut'), deviceId: ''}
      this.genericFunc.genericFunction(datiLogin).subscribe( response => {
        console.log(response);
        if (response.login == 1) {
          this.genericFunc.currentUser = response;
          console.log(this.genericFunc.currentUser);
          this.genericFunc.currentToken = response['token'];
          this.genericFunc.idCart = response['idcar'];
          this.genericFunc.totCart = response.TotProdCar;
          this.genericFunc.minimoOrd = response.MinimoOrd;
          this.genericFunc.changeItemCart(response.TotProdCar);
          
          
          this.genericFunc.changeLoggato(true);
          this.genericFunc.changeCurrentUser(response);
          this.loggato = true;
          this.getSlide();
          this.getProdottiEvidenza();
          this.getProdottiPromo();
          this.getProdottiEv();
          this.getProdottiVenduti();
          
        } else {
          this.genericFunc.loggato = false;
          this.genericFunc.currentToken = '';
          this.genericFunc.idCart = '';
          //this.router.navigateByUrl('accedi');
          this.genericFunc.changeLoggato(false);

          this.getProdottiEvidenza();
          this.getProdottiPromo();
          this.getProdottiEv();
          this.getProdottiVenduti();
          this.getSlide();
        }
      });
    } else {
      this.getProdottiEvidenza();
      this.getProdottiEv();
      /* this.getProdottiPromo();
      
      this.getProdottiVenduti(); */
      this.getSlide();
      this.loggato = this.genericFunc.loggato;
    }
    
  }

  getSlide() {
    let datiSlide = {func: "SliderHome"};
    this.genericFunc.genericFunction(datiSlide).subscribe(response => {
      this.listaSlide = response.Slide;
      
    });
  }

  getProdottiEvidenza() {
    console.log("loggato: " + this.loggato);
    let datiProdotti = {func: "HomeProd", tipo: "1", token: this.genericFunc.currentToken};
    this.genericFunc.genericFunction(datiProdotti).subscribe(response => {
      this.listaProdotti = response.prodhome;
      for (let i = 0; i < this.listaProdotti.length; i++) {
        this.listaProdotti[i].qty = 1;
        
      }
      
    });
  }

  getProdottiPromo() {
    let datiProdotti = {func: "HomeProd", tipo: "2", token: this.genericFunc.currentToken};
    this.genericFunc.genericFunction(datiProdotti).subscribe(response => {
      this.listaProdottiPromo = response.prodhome;
      for (let i = 0; i < this.listaProdottiPromo.length; i++) {
        this.listaProdottiPromo[i].qty = 1;
        
      }
    });
    
  }

  getProdottiEv() {
    let datiProdotti = {func: "HomeProd", tipo: "3", token: this.genericFunc.currentToken};
    this.genericFunc.genericFunction(datiProdotti).subscribe(response => {
      this.listaProdottiEvidenza = response.prodhome;
      for (let i = 0; i < this.listaProdottiEvidenza.length; i++) {
        this.listaProdottiEvidenza[i].qty = 1;
        
      }
    });
  }

  getProdottiVenduti() {
    let datiProdotti = {func: "HomeProd", tipo: "4", token: this.genericFunc.currentToken};
    this.genericFunc.genericFunction(datiProdotti).subscribe(response => {
      this.listaProdottiVenduti = response.prodhome;
      for (let i = 0; i < this.listaProdottiVenduti.length; i++) {
        this.listaProdottiVenduti[i].qty = 1;
        
      }
    });
  }

  
}
